import {
  APIPaymentMethod,
  APITransaction,
  APITransactionApprovalStatus,
  PaymentMethod,
  Transaction,
  TransactionApprovalStatus,
} from "@zyno/lib";

const SORTING_MAP = {
  type: "type",
  updatedBy: "updated_by",
  timestamp: "timestamp",
  amount: "amount",
  tax: "tax",
  adjustment: "adjustment",
  invoiceNumber: "invoice_number",
  description: "description",
  paymentMethod: "payment_method",
  category: "category",
  categoryGroup: "category_group",
  branchName: "branch",
  total: "total",
};

export const getColorFromType = (type: string) => {
  return type === "Ingreso" ? "#81b562" : "text.primary";
};

export const mapAPITransactionToTransaction = (
  transaction: APITransaction
): Transaction => {
  return {
    createdAt: transaction.created_at,
    updatedAt: transaction.updated_at,
    isDeleted: transaction.is_deleted,
    deletedAt: transaction.deleted_at,
    type: transaction.type === "income" ? "Ingreso" : "Gasto",
    amount: transaction.amount,
    tax: transaction.tax,
    adjustment: transaction.adjustment,
    total: transaction.amount + transaction.tax + transaction.adjustment,
    invoiceNumber: transaction.invoice_number,
    description: transaction.description || "",
    category: transaction?.category?.name,
    categoryGroup: transaction?.category?.group?.name,
    categoryColor: transaction?.category?.color,
    categoryId: transaction?.category?.id,
    orgId: transaction.org_id,
    companyId: transaction.company_id,
    id: transaction.id,
    groupId: transaction.group_id,
    timestamp: transaction.timestamp,
    version: transaction.version,
    updatedBy: transaction.updated_by,
    files: transaction.images
      ? transaction.images.map((image) => ({
          id: image.id,
          image_url: image.image_url,
          content_type: image.content_type,
          presigned_url:
            (image as any).presigned_url ?? image.image_url,
        }))
      : undefined,
    branchId: transaction.branch?.id || null,
    branchName: transaction.branch?.name || null,
    departmentId: transaction.department?.id || null,
    departmentName: transaction.department?.name || null,
    approvalStatus: getApprovalStatus(transaction.approval_status),
    paymentMethod: getPaymentMethod(transaction.payment_method),
    contact: transaction.contact
      ? {
          id: transaction.contact.id,
          name: transaction.contact.name,
        }
      : undefined,
    account: transaction.account
      ? {
          id: transaction.account.id,
          name: transaction.account.name,
          number: transaction.account.number,
        }
      : undefined,
    tags: transaction.tags,
  };
};

export const getAPITransactionApprovalStatus = (
  status: TransactionApprovalStatus
) => {
  if (status === TransactionApprovalStatus.APPROVED) {
    return APITransactionApprovalStatus.APPROVED;
  }
  if (status === TransactionApprovalStatus.REJECTED) {
    return APITransactionApprovalStatus.REJECTED;
  }
  return APITransactionApprovalStatus.PENDING;
};

export const getApprovalStatus = (status: APITransactionApprovalStatus) => {
  if (status === APITransactionApprovalStatus.APPROVED) {
    return TransactionApprovalStatus.APPROVED;
  }
  if (status === APITransactionApprovalStatus.REJECTED) {
    return TransactionApprovalStatus.REJECTED;
  }
  return TransactionApprovalStatus.PENDING;
};

export const getPaymentMethod = (paymentMethod: APIPaymentMethod) => {
  if (paymentMethod === APIPaymentMethod.CREDIT_CARD) {
    return PaymentMethod.CREDIT_CARD;
  } else if (paymentMethod === APIPaymentMethod.BANK) {
    return PaymentMethod.BANK;
  } else {
    return PaymentMethod.CASH;
  }
};

export const getPaymentMethodFromTransaction = (transaction: Transaction) => {
  if (transaction.paymentMethod === PaymentMethod.CREDIT_CARD) {
    return APIPaymentMethod.CREDIT_CARD;
  } else if (transaction.paymentMethod === PaymentMethod.BANK) {
    return APIPaymentMethod.BANK;
  } else {
    return APIPaymentMethod.CASH;
  }
};

export const toBackendSorting = (sortBy: string | undefined) => {
  if (sortBy && sortBy in SORTING_MAP) {
    return SORTING_MAP[sortBy as keyof typeof SORTING_MAP];
  } else {
    return undefined;
  }
};
